import styled from 'styled-components';
import Button from '../components/Common/Button';
import DatePicker from '../components/DatePicker';

export const StyledGoNextMonthButton = styled(Button)`
  && {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    padding-top: 9px;
    padding-bottom: 9px;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  position: relative;
`;
